<template>
    <el-dialog :model-value="!!type" :closeIcon="closeIcon" @close="handleClose" :title="title" class="!w-50vw" align-center>
        <div class="max-h-80vh overflow-y-scroll mr-8px pr-8px pb-24px">
            <PublicBetaAgreement v-if="type === DialogContentType.PUBLIC_BETA" />
            <ServiceAgreement v-else-if="type === DialogContentType.SERVICE_AGREEMENT" />
            <UserGuide v-else-if="type === DialogContentType.USER_GUIDE" />
            <PrivatePolicy v-else-if="type === DialogContentType.PRIVACY" />
            <ProhibitedConduct v-else-if="type === DialogContentType.PROHIBITED_CONDUCT" />
        </div>
    </el-dialog>
</template>

<script setup lang="tsx">
import Icon from '@/components/Icon/src/Icon.vue';
import { DialogContentType } from '../config';
import PrivatePolicy from './PrivatePolicy.vue';
import PublicBetaAgreement from './PublicBetaAgreement.vue';
import ServiceAgreement from './ServiceAgreement.vue';
import UserGuide from './UserGuide.vue';
import ProhibitedConduct from './ProhibitedConduct.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const closeIcon = () => {
    return <Icon size={16} icon={'svg-icon:close'} />;
};

withDefaults(defineProps<{
    type?: DialogContentType;
}>(), {  })
const map = {
    [DialogContentType.PUBLIC_BETA]: computed(() => t('common.agreement2')),
    [DialogContentType.SERVICE_AGREEMENT]: computed(() => t('common.agreement1')),
    [DialogContentType.USER_GUIDE]: computed(() => t('common.agreement4')),
    [DialogContentType.PRIVACY]: computed(() => t('common.agreement3')),
    [DialogContentType.PROHIBITED_CONDUCT]: computed(() => t('common.agreement2')),
};
const title = computed(() => (__props.type ? map[__props.type].value : ''));
const emit = defineEmits(['close']);
const handleClose = () => {
    emit('close');
};
</script>

<style lang="scss">
:deep(.el-overlay) {
    background-color: transparent;
}
.el-dialog__title {
    font-weight: 600 !important;
    color: var(--text-color) !important;
    // .multi-icon {
    //     font-size: 14px !important;
    // }
}
.el-dialog__headerbtn {
    top: 10px !important;
    margin-right: 20px !important;
    // .el-icon {
    //     &:hover,
    //     &:active {
    //         color: var(--text-color);
    //     }
    // }
}
.el-dialog__body {
    width: 100%;
}
</style>
